import { makeStyles } from '@material-ui/core/styles';

const arrowMatchUrl = new URL('./arrow-matches.svg', import.meta.url).href;

const useStyles = makeStyles((theme) => ({
  customerLink: {
    fontSize: 16,
    color: theme.colorPalette.green_90
  },
  matchCustomer: {
    background: theme.colorPalette.beige_25,
    padding: '8px 20px 7px 5px',
    borderRadius: '3px 3px 3px 3px',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    right: '7%'
  },
  potentialMatches: {
    backgroundImage: `url("${arrowMatchUrl}")`,
    width: 320,
    height: 57,
    objectFit: 'contain',
    borderRadius: 6,
    padding: '8px 0 8px 24px'
  },
  noMatchOffer: {
    background: 'transparent',
    borderRadius: '3px 3px 3px 3px',
    borderStyle: 'solid',
    borderColor: theme.colorPalette.white
  },
  matchLabel: {
    whiteSpace: 'pre'
  },
  matchAction: {
    color: theme.colorPalette.white,
    fontSize: 12
  },
  matchAction2: {
    color: theme.colorPalette.orange_50,
    fontSize: 12
  },
  subtitle: {
    paddingRight: 10
  },
  subtitleOrange: {
    paddingRight: 10,
    color: theme.colorPalette.orange_50
  },
  hover: {
    cursor: 'pointer'
  },
  noPotentialMatches: {
    background: 'transparent',
    padding: theme.spacing(5),
    marginRight: theme.spacing(5),
    borderRadius: '3px 3px 3px 3px',
    borderStyle: 'solid',
    borderColor: theme.colorPalette.white
  },
  copyButton: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: '50%'
  },
  simulatedSourceBadge: {
    '&&': {
      maxWidth: 'none',
      backgroundColor: theme.colorPalette.beige_25,
      color: theme.colorPalette.beige_90
    }
  },
  titleLink: {
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'underline',
    textUnderlineOffset: 4
  }
}));

export default useStyles;
